import { registerTour } from '@/features/tours';
import { FEATURE_FLAGS } from '@/features/featureFlags';
import { filtersStep, listTableStep, newMeetingStep } from './steps';

export const MEETINGS_LIST_TOUR_ID = 'meetings.list';

registerTour({
  id: MEETINGS_LIST_TOUR_ID,
  name: 'Meeting Minutes',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.MEETING_MINUTES.id,
  steps: [
    {
      id: 'welcome',
      title: 'Welcome to Meeting Minutes',
      body:
        'Plan project meetings, track who attended, and keep a permanent ' +
        'record of agendas, summaries, decisions, and action items.',
    },
    newMeetingStep,
    filtersStep,
    listTableStep,
  ],
});
